$(function() {
    window.addEventListener('load', function() {
        if ($('.values')[0]) {
            const boxes = document.querySelectorAll('.values__iconWrap');
            boxes.forEach(box => {
                box.addEventListener('mouseenter', () => {
                    box.classList.add('active');
                    const parentItem = box.closest('.values__item');
                    if (parentItem) {
                        parentItem.classList.add('active');
                    }

                    boxes.forEach(otherBox => {
                        if (otherBox !== box) {
                            otherBox.classList.remove('active');
                            const otherParentItem = otherBox.closest('.values__item');
                            if (otherParentItem) {
                                otherParentItem.classList.remove('active');
                            }
                        }
                    });
                });
            });
        }
    });
});
